import { BrowserModule } from '@angular/platform-browser';
import {
    NgModule,
    NO_ERRORS_SCHEMA,
    CUSTOM_ELEMENTS_SCHEMA,
} from '@angular/core';
import { AppComponent } from './app.component';
import {
    provideHttpClient,
    withInterceptorsFromDi,
    withXhr,
} from '@angular/common/http';
import { AppRoutingModule } from './app.routing';
import { CoreModule } from '@masar/core/core.module';
import { MnmWebappModule } from 'mnm-webapp';
import { EasterModule } from '@masar/features/easter/easter.module';
import { GuideBotModule } from './features/guide-bot/guide-bot.module';
import { SharedModule } from '@masar/shared/shared.module';
@NgModule({
    declarations: [AppComponent],
    schemas: [NO_ERRORS_SCHEMA, CUSTOM_ELEMENTS_SCHEMA],
    bootstrap: [AppComponent],
    imports: [
        BrowserModule,
        AppRoutingModule,
        CoreModule,
        MnmWebappModule,
        EasterModule,
        GuideBotModule,
        SharedModule,
    ],
    providers: [provideHttpClient(withXhr(), withInterceptorsFromDi())],
})
export class AppModule {}
